import "core-js/modules/web.self.js";
import { computed, defineComponent } from 'vue';
import { mapState, mapGetters, useStore } from 'vuex';
import { isAndroidNative as isAndroid, isIOSNative as isIOS, isHarmonyNative } from '@xunlei/universal-native-api';
import { IconHome } from '@xunlei/thunder-icon-vue';
import { useEnvStore } from '@remote/store/env';
import { useDeviceStore } from '@remote/store/device';
import { openDeviceList } from '@remote/utils/dialog';
export default defineComponent({
  name: 'HeaderPlus',
  components: {
    IconHome
  },
  setup: () => {
    const store = useStore();
    const envStore = useEnvStore();
    const isDev = process.env.NODE_ENV === 'development';
    const deviceStore = useDeviceStore();
    const currentDeviceName = computed(() => {
      var _deviceStore$currentD, _deviceStore$currentD2;
      return (_deviceStore$currentD = (_deviceStore$currentD2 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD2 === void 0 ? void 0 : _deviceStore$currentD2.runnerTaskRef.name) !== null && _deviceStore$currentD !== void 0 ? _deviceStore$currentD : isDev ? '迅雷-远程设备本地' : '迅雷-远程设备';
    });
    return {
      store,
      isDev,
      envStore,
      openDeviceList,
      currentDeviceName
    };
  },
  data() {
    return {
      showDevice: false,
      isAndroid,
      isIOS,
      isHarmonyNative
    };
  },
  computed: {
    ...mapState(['all', 'user', 'isSelect', 'checking', 'inListFiles', 'isApp', 'isMiniProgram', 'isVip', 'taskType']),
    ...mapGetters(['isLogin', 'isSuperVip', 'showHeader', 'showVip', 'isVip', 'runningList', 'isFullScreen']),
    status() {
      var _deviceStore$currentD3;
      const deviceStore = useDeviceStore();
      return ((_deviceStore$currentD3 = deviceStore.currentDeviceRef) === null || _deviceStore$currentD3 === void 0 ? void 0 : _deviceStore$currentD3.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    },
    disabled() {
      return this.isSelect;
    },
    isNative() {
      return (isAndroid || isIOS || isHarmonyNative || this.isApp || this.isMiniProgram) && self === top;
    },
    showSpeedUp() {
      return !this.isVip && this.showVip && this.user && this.$route.path !== '/me' && this.$route.path !== '/plugin' && this.$store.getters.showVip;
    },
    showVipSpeedUp() {
      return this.runningList.length > 0 && this.taskType === 'ing' && this.isVip && this.status && this.$route.path !== '/me' && this.$route.path !== '/plugin';
    },
    isUseIOSHeader() {
      var _window, _window2;
      // iOS迅雷和华为浏览器，webview是全屏的，所以要用适配全面屏的header
      return isIOS || Boolean((_window = window) === null || _window === void 0 || (_window = _window.webkit) === null || _window === void 0 || (_window = _window.messageHandlers) === null || _window === void 0 ? void 0 : _window.hdc) || Boolean((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webkit) === null || _window2 === void 0 || (_window2 = _window2.messageHandlers) === null || _window2 === void 0 ? void 0 : _window2.xlremote);
    }
  },
  methods: {
    async callAppHome() {
      let routename = String(this.$route.name);
      if (!this.isNative) return;
      if (!['home', 'login', 'me', 'plugin'].includes(routename)) {
        this.$router.back();
      } else {
        this.store.dispatch('close');
      }
    },
    goVip() {
      this.$stat({
        action: 'download_tab_top_vipspeed_btn_click'
      });
      this.$stat({
        action: 'vip_accelerate_btn_click'
      });
      this.store.dispatch('goVip', {
        position: 'hyjs'
      });
    },
    onOpenDeviceList() {
      if (this.isLogin) {
        openDeviceList({
          actionFrom: 'homepage'
        });
      }
    }
  }
});